import { FIELD_NAMES } from '../../constants';

const PHONE_FIELDS = [FIELD_NAMES.HOME_PHONE, FIELD_NAMES.MOBILE_PHONE];

/**
 * The data the edit form renders.
 *
 * A form app that saved this field to the form only — rather than to the
 * profile — holds the newer value, so its data wins over the copy in the
 * profile store. Everything else renders the field value as-is.
 */
export const getEditViewFormData = ({ field, fieldName, formFieldData }) => {
  if (formFieldData?.formOnlyUpdate !== true) {
    return field?.value;
  }

  const merged = { ...field?.value, ...formFieldData };

  // The phone fields keep a combined area code + number for display, which the
  // merge above would otherwise leave pointing at the old number.
  if (PHONE_FIELDS.includes(fieldName) && formFieldData.phoneNumber) {
    merged.inputPhoneNumber =
      formFieldData.areaCode + formFieldData.phoneNumber;
  }

  return merged;
};
